import { cn, createBEM } from "@/libs";
import "./index.scss";

type SpaceItemProps = {
  className?: string;
  left?: React.ReactNode;
  children?: React.ReactNode;
  right?: React.ReactNode;
  center?: boolean;
};

export const SpaceContent: React.FC<SpaceItemProps> = (props) => {
  const b = createBEM("i-space");
  return (
    <div className={cn(b(), props.className)}>
      <div className={b("left")}>{props.left}</div>
      {props.center === true ? <div className={b("space")} /> : null}
      <div className={b("content")}>{props.children}</div>
      <div className={b("space")} />
      <div className={b("right")}>{props.right}</div>
    </div>
  );
};
